import type { TaxCodesQueryParams, TaxCodesResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodTaxCodesQueryParamsSchema,
  zodTaxCodesResponseSchema,
} from './validations';

/**
 * Fetches the tax codes matching the given filters.
 *
 * @param queryParams - Filters and pagination for the tax-code list.
 * @param options - Additional request options.
 * @returns The paginated tax-code response.
 * @see https://app.dev.vestigas.com/redoc#tag/Tax-Codes
 */
export const fetchTaxCodes = async (
  queryParams: Partial<TaxCodesQueryParams>,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.TAX_CODE.GET_ALL(), {
      searchParams: withoutObjectKeysWhereValueIs(queryParams, [
        undefined,
        '',
      ]) as Record<string, boolean | number | string | undefined>,
      ...options,
      validate: {
        ...options?.validate,
        response: zodTaxCodesResponseSchema,
        searchParams: zodTaxCodesQueryParamsSchema,
      },
    })
    .json<TaxCodesResponse>();
